import {  call, put, takeEvery } from 'redux-saga/effects';

import {
  FETCH_USERS_REQUESTED,
  FETCH_USER_PHOTO_REQUESTED,
  FETCH_USER_REQUESTED,
  EDIT_USER_REQUESTED,
  FETCH_USER_PHOTO_UPLOAD_REQUESTED, FETCH_USER_PHOTO_SAVE_REQUESTED
} from '../store/users/actionTypes';

import Api from '../lib/Api'

import {
  editUserFailed,
  editUserSucceeded,
  fetchUserFailed,
  fetchUserGalleryFailed,
  fetchUserGallerySucceeded, fetchUserPhotoSaveFailed, fetchUserPhotoSaveSucceeded,
  fetchUserPhotoUploadFailed,
  fetchUserPhotoUploadSucceeded,
  fetchUsersFailed,
  fetchUsersSucceeded,
  fetchUserSucceeded
} from '../store/users/actions';

const _getUsersRequested = (params) => {
  return Api.getUsersList(params)
    .then((response) => response)
    .catch((e) => e.response)
}

const _getUserRequested = (params) => {
  return Api.getUserDetail(params)
    .then((response) => response)
    .catch((e) => e.response)
}
const _getUserGalleryRequested = (params) => {
  return Api.getUsersGallery(params)
    .then((response) => response)
    .catch((e) => e.response)
}

const _postUserPhotoCreateRequested = (params) => {
  return Api.postGalleryCreate(params)
    .then((response) => response)
    .catch((e) => e.response)
}

const _postUserGalleryUpdateRequested = (params) => {
  return Api.postUserGalleryUpdate(params)
    .then((response) => response)
    .catch((e) => e.response)
}

const _postUserEditRequested = (params) => {
  return Api.postUsersEdit(params)
    .then((response) => response)
    .catch((e) => e.response)
}

function* fetchUsers(action) {
  try {
    const response = yield call(_getUsersRequested, action.payload)
    const {data:{data:users}}=response
    yield put(fetchUsersSucceeded({ users }));
  } catch (error) {
    yield put(fetchUsersFailed(error));
  }
}

function* fetchUser(action) {
  try {
    const response = yield call(_getUserRequested, action.payload)
    const {data:{data:user}}=response
    yield put(fetchUserSucceeded({user}));
  } catch (error) {
    yield put(fetchUserFailed(error));
  }
}

function* fetchUserGallery(action) {
  try {
    const response = yield call(_getUserGalleryRequested, action.payload)
    const {data:{data:photos}}= response
    yield put(fetchUserGallerySucceeded({photos}));
  } catch (error) {
    yield put(fetchUserGalleryFailed(error));
  }
}
function* userPhotoCreate(action) {
  try {
    const response = yield call(_postUserPhotoCreateRequested, action.payload)
    const {data:{data:photo}}= response
    yield put(fetchUserPhotoUploadSucceeded({photo:{...photo,tags: [{value: "New", title: "New"}]}}));
  } catch (error) {
    yield put(fetchUserPhotoUploadFailed(error));
  }
}

function* userPhotoSave(action) {
  try {
    const response = yield call(_postUserGalleryUpdateRequested, action.payload)
    const {data:{data:photos}} = response
    yield put(fetchUserGallerySucceeded({photos}));
  } catch (error) {
    yield put(fetchUserPhotoSaveFailed(error));
  }
}

function* editUser(action) {
  try {
    const { editedUser } = action.payload
    const userData = {
      id: editedUser.id,
      display_name: editedUser.display_name,
      phone_number: editedUser.phone_number,
      instagram_account: editedUser.instagram_account || null,
      vk_account: editedUser.vk_account || null,
      facebook_account: editedUser.facebook_account || null,
      description: editedUser.description || null,
      internal_description: editedUser.internal_description || null,
      skills: (editedUser.skills || []).map((eachSkill) => eachSkill.id),
      cities: (editedUser.cities || []).map((city) => city.id)
    };
    yield call(_postUserEditRequested, userData)
    yield put(editUserSucceeded());
  } catch (error) {
    yield put(editUserFailed(error));
  }
}

function* UsersSaga() {
  yield takeEvery(FETCH_USERS_REQUESTED, fetchUsers);
  yield takeEvery(FETCH_USER_REQUESTED, fetchUser);
  yield takeEvery(EDIT_USER_REQUESTED, editUser);
  yield takeEvery(FETCH_USER_PHOTO_REQUESTED, fetchUserGallery);
  yield takeEvery(FETCH_USER_PHOTO_UPLOAD_REQUESTED, userPhotoCreate);
  yield takeEvery(FETCH_USER_PHOTO_SAVE_REQUESTED, userPhotoSave);
}

export default UsersSaga



// WEBPACK FOOTER //
// ./src/saga/users.js